import React from 'react';
import LoginBanner from '../../components/Login/LoginBanner/LoginBanner';

const Login = () => {
    return (
        <div>
            <LoginBanner/>
        </div>
    );
};

export default Login;